import './App.css';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Home from './Home';
import Support from './Support';
import { SiteI18nProvider } from './i18n/siteI18n';

function App() {
  return (
    <SiteI18nProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </Router>
    </SiteI18nProvider>
  );
}

export default App;
